import APIClient from './index';

const unwrap = response => {
  if (!response.data?.success) throw new Error(response.data?.error || 'Could not complete this request');
  return response.data;
};
export const searchCircles = (q, page = 0, filters = {}) =>
  APIClient.get('/CuratorGroups/editor/search', { params: { q, page, ...filters } }).then(unwrap);
export const searchCircleCreators = q => APIClient.get('/CuratorGroups/editor/creators', { params: { q } }).then(unwrap);
export const getCircleCategories = () => APIClient.get('/Public/Catalog/hierarchy').then(unwrap);
export const saveCircle = circle => APIClient.post('/CuratorGroups/editor/save', circle).then(unwrap);
export const getCirclePlacement = placement => APIClient.get(`/ShopFeatures/placements/${placement}`).then(unwrap);
export const publishCirclePlacement = (placement, features, revision) =>
  APIClient.put(`/ShopFeatures/placements/${placement}`, { features, revision }).then(unwrap);

export const getOnboardingBrands = () => APIClient.get('/ShopFeatures/placements/onboarding', { params: { type: 'brand' } }).then(unwrap);
export const publishOnboardingBrands = (features, revision) =>
  APIClient.put('/ShopFeatures/placements/onboarding', { features, revision }, { params: { type: 'brand' } }).then(unwrap);
export const searchFeaturedBrands = q => APIClient.get('/ShopFeatures/search_brands', { params: { q } }).then(unwrap);
